var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"w-full pb-60 md:pb-0"},[_c('MyAccountHeader',{attrs:{"account-tabs":_vm.accountTabs}}),_c(_vm.currentComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }